export default "__VITE_ASSET__Wn8t9aBVxhW6paSmpVtb7g__"